import React, { Component } from 'react'
import { throttle, get } from 'lodash'

import './address-geocode.sass'
import axiosClient from '../../api/axios-client'

class AddressGeocode extends Component {
  static defaultProps = {
    apiCallFrequency: 1000,
    minimumLength: 8,
    onlyFrance: false,
    allowDomiciliationAddresses: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      value: get(props, 'field.value') || '',
      dropdownOpened: false,
      addresses: [],
    }

    this.throttleGeocode = throttle(this.geocodeAddress.bind(this), props.apiCallFrequency)
  }

  componentDidUpdate(prevProps) {
    if (get(prevProps, 'field.value') !== get(this.props, 'field.value')) {
      this.setState({
        value: get(this.props, 'field.value'),
        dropdownOpened: false,
      })
    }
  }

  async geocodeAddress(address) {
    const { onError, onlyFrance, minimumLength, allowDomiciliationAddresses } = this.props
    if (address.length < minimumLength) return

    try {
      const result = await axiosClient.get('/api/geocode/get', {
        params: {
          address,
          'only-france': onlyFrance,
          'allow-dom': allowDomiciliationAddresses,
        },
      })

      const { results, domiAddresFound, onlyOutsideFranceFound } = result.data
      
      if (!results.length) {
        if (onlyOutsideFranceFound) {
          onError('Merci de sélectionner une adresse en France')
        }
        if (domiAddresFound) {
          onError('Ce champ ne doit pas contenir une de nos adresses de domiciliation')
        }
        this.setState({
          addresses: [],
          dropdownOpened: false,
        })
        return
      }

      this.setState({
        addresses: results,
        dropdownOpened: true,
      })
    } catch (e) {
      console.log(e)
      onError('Une erreur est survenue lors de la vérification de cette adresse, merci de la formuler différemment.')
    }
  }

  handleChange(value) {
    this.setState({ value })
    this.props.onChange(value)

    this.throttleGeocode(value)
  }

  renderDropDown() {
    const { dropdownOpened, addresses } = this.state
    const { onSelect } = this.props
    const { onChange } = this.props.field

    if (!dropdownOpened) return null

    const options = addresses.map(address => (
      <div
        onClick={() => {
          this.setState({
            dropdownOpened: false,
            value: address.formattedAddress,
          })
          onChange(address.formattedAddress)
          onSelect(address)
        }}
        className="AddressGeocode-dropdown-address"
        key={address.formattedAddress}
      >
        {address.formattedAddress}
      </div>
    ))

    return (
      <div className="AddressGeocode-dropdown">
        <div className="AddressGeocode-dropdown-title">
          Merci de sélectionner votre adresse dans cette liste
        </div>
        {options}
      </div>
    )
  }

  render() {
    const { placeholder, field } = this.props

    return (
      <div className="AddressGeocode">
        <input
          type="text"
          name={field.name}
          value={this.state.value}
          onChange={e => this.handleChange(e.target.value)}
          placeholder={placeholder}
          onBlur={field.onBlur}
        />
        {this.renderDropDown()}
      </div>
    )
  }
}

export default AddressGeocode
